import React, { useEffect, useState } from "react";
import ApiSession from "../api/ApiSession";
const apiSession = new ApiSession();
const quantityResources = {
    Utility: {
      quantityOfPowerMeters: 0,
      quantityOfDevices: 0,
      quantityOfCircuitBreakers: 0,
      quantityOfResources: 0,
      quantityOfTagsPerHours: 0,
      quantityOfTags: 0,
    },
    Genset: {
      quantityOfPowerMeters: 0,
      quantityOfDevices: 0,
      quantityOfCircuitBreakers: 0,
      quantityOfResources: 0,
      quantityOfTagsPerHours: 0,
      quantityOfTags: 0,
    },
    BESS: {
      quantityOfPowerMeters: 0,
      quantityOfDevices: 0,
      quantityOfCircuitBreakers: 0,
      quantityOfResources: 0,
      quantityOfTagsPerHours: 0,
      quantityOfTags: 0,
    },
    "PV Branch 1": {
      quantityOfPowerMeters: 0,
      quantityOfDevices: 0,
      quantityOfCircuitBreakers: 0,
      quantityOfResources: 0,
      quantityOfTagsPerHours: 0,
      quantityOfTags: 0,
    },
    "PV Branch 2": {
      quantityOfPowerMeters: 0,
      quantityOfDevices: 0,
      quantityOfCircuitBreakers: 0,
      quantityOfResources: 0,
      quantityOfTagsPerHours: 0,
      quantityOfTags: 0,
    },
    "PV Branch 3": {
      quantityOfPowerMeters: 0,
      quantityOfDevices: 0,
      quantityOfCircuitBreakers: 0,
      quantityOfResources: 0,
      quantityOfTagsPerHours: 0,
      quantityOfTags: 0,
    },
    Load: {
      quantityOfPowerMeters: 0,
      quantityOfDevices: 0,
      quantityOfCircuitBreakers: 0,
      quantityOfResources: 0,
      quantityOfTagsPerHours: 0,
      quantityOfTags: 0,
    },
    // MICROGRID: {
    //   quantityOfPowerMeters: 0,
    //   quantityOfDevices: 0,
    //   quantityOfCircuitBreakers: 0,
    //   quantityOfResources: 0,
    //   quantityOfTagsPerHours: 0,
    //   quantityOfTags: 0,
    // },
  }
  
const numbers = Array.from({ length: 11 }, (_, i) => i);
const Help = () => {
  const [loading, setLoading] = useState(false);
  const [referenceTags, setReferenceTags] = useState();
  const [projectTypes, setProjectTypes] = useState({});
  const [microGridTagsTotal, setMicroGridTagsTotal] = useState(0);
  const [selectMicroGridTag, setSelectMicroGridTag] = useState(1);
  const [isMicroGridEnable, setIsMicroGridEnable] = useState(false);
  const [selectProject, setSelectProject] = useState({
    region: "ANSI",
    application: "Buildings",
    energyManagementSystem: "Autogrid Flex",
  });
  const [dataTraffic, setDataTraffic] = useState(quantityResources);
  const [quantityList, setQuantityList] = useState(numbers);
  useEffect(() => {
    setDataTraffic(quantityResources);
    setIsMicroGridEnable(false);
    setMicroGridTagsTotal(0)
  }, [selectProject]);
  useEffect(()=>{
    setLoading(true)
   apiSession
    .getQuantityOfResource()
    .then(response =>{
      if(response){
        setReferenceTags(response);
         setLoading(true)
      }
      
    });
    getProjectsList();
  },[]);
  const getProjectsList = () => {
    apiSession
      .getProjectTypes()
      .then((json) => {
        setProjectTypes(json);
      })
      .catch((err) => {
        // Do Nothing
      });
  };
  const projectType =()=>{
    if(selectProject.energyManagementSystem === 'Microgrid Advisor'){
        if(selectProject.region === "IEC" || selectProject.region === "ETO"){
          return selectProject.region === "IEC" ?selectProject.application ==="Access to Energy"?"Access to Energy": "MGaaS IEC":"MGaaS ETO"
        }else{
            return  "MGaaS ANSI"
        }
    }else{
        if(selectProject.region === "IEC" ){
          return  "DaaS IEC"
        }else{
            return  "DaaS ANSI"
        }
    }
}
  useEffect(()=>{
    console.log(projectType())
  },[selectProject])
  const onChangeMicrogridType = (e) => {
    const { value } = e?.target;
    const energyMgtSelect = projectTypes?.[e?.target?.value]?.filter(
      (a) => a?.energyManagementSystem === "Autogrid Flex"
    );
    setSelectProject((prev) => {
      return {
        ...prev,
        region: value,
        application: "Buildings",
        energyManagementSystem:
          // energyMgtSelect.length > 0
          //   ? "Autogrid Flex"
          //   : energyMgtSelect?.[0]?.energyManagementSystem ??
              "Microgrid Advisor",
      };
    });
  };
  const onChangeSubProjectType = (e) => {
    const { value } = e.target;
    if (
      e.target.value === "Access to Energy" &&
      selectProject.region === "IEC"
    ) {
      setSelectProject((prev) => {
        return {
          ...prev,
          application: value,
          energyManagementSystem: "Microgrid Advisor",
        };
      });
    } else {
      setSelectProject((prev) => {
        return {
          ...prev,
          application: value,
        };
      });
    }
  };

  const onChangeEnergyManagementSystem = (e) => {
    const { value } = e.target;
    setSelectProject((prev) => {
      return {
        ...prev,
        energyManagementSystem: value,
      };
    });
  };
  
const  calculateTotalTags = ()=>{
 let totalTags = 0;
 for (const key in dataTraffic) {
 if (dataTraffic[key].hasOwnProperty('quantityOfTags')) {
 totalTags += dataTraffic[key].quantityOfTags ;
 }
 }
 return totalTags;
}

const handleQuantityChange = (e, resource, device) => {
  setIsMicroGridEnable(true);
  const { name, value } = e.target;
  const newQuantity = parseInt(value);
  
  setDataTraffic((prev) => {
    const updatedData = {
      ...prev,
      [resource]: {
        ...prev[resource],
        [device]: newQuantity,
      }
    };
    
    const updatedTagsData = calculateQuantityOfTags(updatedData);
    return updatedTagsData; 
  });
};

const calculateQuantityOfTags = (data) => {
    const updatedData = { ...data };
    const pType = projectType(); 
    const selectedProject = referenceTags && referenceTags?.[pType];

    if (!selectedProject) {
        console.error("Selected project data is not available.");
        return updatedData; 
    }

    let microGridTags = selectedProject.microgridTags["*"] || 0; 

    for (const section in updatedData) {
        const key = ["PV Branch 1", "PV Branch 2", "PV Branch 3"].includes(section)
            ? "PV"
            : section;

        const powerMeterTags = selectedProject?.tagNumbersMap[key]?.powerMeterTags || 0;
        const circuitBreakerTags = selectedProject?.tagNumbersMap[key]?.circuitBreakerTags || 0;
        const deviceTags = selectedProject?.tagNumbersMap[key]?.deviceTags  || 0;
        const resourceTags = ((updatedData[section]?.quantityOfPowerMeters === 0 &&( section !== "Load" || section !== "Utility" ))||
                              updatedData[section]?.quantityOfCircuitBreakers === 0 ||
                              updatedData[section]?.quantityOfDevices === 0) ? 0:
                              selectedProject?.tagNumbersMap[key]?.resourceTags || 0;

        const totalTags = (
            (powerMeterTags *( updatedData[section]?.quantityOfPowerMeters)) +
            (circuitBreakerTags * (updatedData[section]?.quantityOfCircuitBreakers)) +
            (deviceTags * (updatedData[section]?.quantityOfDevices)) + resourceTags
        );

       
        updatedData[section].quantityOfTags = totalTags;

       
        if (
            ["PV Branch 1", "PV Branch 2", "PV Branch 3","Genset", "BESS"].includes(section)
        ) {
            const sectionTags = selectedProject.microgridTags[key.toUpperCase()] || 0; 
            microGridTags += (sectionTags *( updatedData[section].quantityOfDevices)) ; 
        }
    }

    console.log("Updated microGridTags:", microGridTags);
    setMicroGridTagsTotal(microGridTags)
    return updatedData;
};




  return (
    <div>
    {/* <se-loading loading={loading}></se-loading> */}
    
   { loading && <div className="col-sm-12">
      <div className="row">
        <div className="col-md-12 mt-2 ">
          <span className="se-life-green se-font-14px-bold ">
            Data Traffic Calculation
          </span>
        </div>
      </div>
      <div className="row mt-2">
        {Object.keys(projectTypes).length !== 0 ? (
          <div
            className="form-group mb-0 px-3 d-flex flex-row flex-nowrap "
            style={{ gap: "10px" }}
          >
            <div className="form-group">
              <span>Select Your Region : </span>
              <select
                className="form-control "
                style={{ width: "200px" }}
                id="selectYourRegionHelp"
                name="sortProjectOption"
                value={selectProject.region}
                onChange={onChangeMicrogridType}
              >
                {/* <option value="IEC" disabled selected hidden>
                      IEC
                    </option> */}
                {Object.keys(projectTypes).map((project) => (
                  <option key={project} value={project}>
                    {project}
                  </option>
                ))}
              </select>
            </div>
            {selectProject.region && (
              <div className="form-group">
                <span> Choose Application : </span>
                <select
                  className="form-control "
                  style={{ width: "200px" }}
                  id="chooseApplicationHelp"
                  name="sortProjectOption"
                  value={selectProject.application}
                  onChange={onChangeSubProjectType}
                >
                  <option value="Buildings" disabled selected hidden>
                    Buildings
                  </option>
                  {projectTypes[selectProject.region]
                    ?.filter((item, index, self) => {
                      return (
                        index ===
                        self.findIndex(
                          (t) => t.application === item.application
                        )
                      );
                    })
                    .map((projectType, index) => (
                      <option
                        key={projectType.application}
                        value={projectType.application}
                         disabled={projectType.application === "Access to Energy" ? true : false}
                      >
                        {projectType.application}
                      </option>
                    ))}
                </select>
              </div>
            )}

            {selectProject.application && (
              <div className="form-group">
                <span> Energy Management System : </span>
                <select
                  className="form-control  "
                  style={{ width: "270px" }}
                  id="energyManagementSystemHelp"
                  name="sortProjectOption"
                  value={selectProject.energyManagementSystem}
                  onChange={onChangeEnergyManagementSystem}
                >
                  {/* <option value="Autogrid Flex" disabled selected >
                        Autogrid Flex
                      </option> */}

                  {projectTypes[selectProject.region]
                    ?.filter((item, index, self) => {
                      return item.application === selectProject.application;
                    })
                    .map((projectType, index) => (
                      <>
                        <option
                          key={projectType.energyManagementSystem}
                          value={projectType.energyManagementSystem}
                          disabled={projectType.region === "IEC" &&  projectType.energyManagementSystem === "Autogrid Flex"? true : false}
                        >
                          {projectType.energyManagementSystem}
                        </option>
                      </>
                    ))}
                </select>
              </div>
            )}
          </div>
        ) : (
          <se-loading
            loading={Object.keys(projectTypes).length === 0 ? true : false}
          ></se-loading>
        )}
      </div>
      <div className="table-responsive mt-2">
        <table className="table table-bordered">
          <thead className="text-center">
            <tr>
              <th>Resource</th>
              <th>Quantity of PM</th>
              <th>Quantity of CB </th>
              <th>Quantity of DEVICES </th>
              <th>Quantity of TAGS </th>
            </tr>
          </thead>
          <tbody>
            {Object.keys(dataTraffic).map((resource) => (
              <tr key={resource} className="text-center">
                <td>{resource}</td>
                <td>
                  { resource === "LOADS" ||  resource === "MICROGRID" ? 
                    <div style={{ textAlign: "center", paddingTop: "9px" }}>
                      NA
                    </div> :
                    <select
                      className="form-control form-control-sm"
                      value={dataTraffic[resource]?.quantityOfPowerMeters}
                      onChange={(e) => handleQuantityChange(e, resource, "quantityOfPowerMeters")
                      }
                    >
                      {quantityList.map((tags) => (
                        <option
                          key={tags + "quantityOfPowerMeters"}
                          value={tags}
                        >
                          {tags}
                        </option>
                      ))}
                    </select>
                  }
                </td>
                <td>
                  {  resource === "MICROGRID" ? 
                    <div style={{ textAlign: "center", paddingTop: "9px" }}>
                      NA
                    </div> :
                    <select
                      className="form-control form-control-sm"
                      value={dataTraffic[resource]?.quantityOfCircuitBreakers}
                      onChange={(e) => handleQuantityChange(e, resource, "quantityOfCircuitBreakers")}
                    >
                      {quantityList.map((tags) => (
                        <option
                          key={tags + "quantityOfCircuitBreakers"}
                          value={tags}
                        >
                          {tags}
                        </option>
                      ))}
                    </select>
                  }
                </td>
                <td>
                  {
                    <select
                      className="form-control form-control-sm"
                      value={dataTraffic[resource]?.quantityOfDevices}
                     onChange={(e) => handleQuantityChange(e, resource, "quantityOfDevices")}
                    >
                      {quantityList.slice(0,16).map((tags) => (
                        <option key={tags + "quantityOfDevices"} value={tags}>
                          {tags}
                        </option>
                      ))}
                    </select>
                  }
                </td>
                <td className="text-center">
                  {
                   dataTraffic[resource]?.quantityOfTags 
                  }
                </td>
              </tr>
            ))}
             <tr>
              <td className="text-center">MICROGRID</td>
              <td></td>
              <td></td>
              <td> { isMicroGridEnable &&
                    <select
                      className="form-control form-control-sm"
                      value={selectMicroGridTag}
                     onChange={(e) => setSelectMicroGridTag(e.target.value)}
                    >
                      {quantityList.slice(1,2).map((tags) => (
                        <option key={tags + "MicroGridTag"} value={tags}>
                          {tags}
                        </option>
                      ))}
                    </select>
                  }</td>
              <td className="text-center">{ ( microGridTagsTotal * selectMicroGridTag)}</td>
            </tr>
            <tr>
              <td className="text-center">Total</td>
               <td></td>
                <td></td>
                 <td>
                  
                 </td>
                  <td className="text-center">{calculateTotalTags() + ( microGridTagsTotal * selectMicroGridTag)}</td>
            </tr>
           
          </tbody>
        </table>
      </div>
    </div>} 
    </div>
  );
};

export default Help;
